import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { App, CategoryData, TemplateData } from '../../App';

interface PresentationTemplateRootProps {
    categories: Array<CategoryData>;
    templates: Array<TemplateData>;
    isAuthenticated: boolean;
    preloadTemplatePreviewVideos: boolean;
    categoryString: string;
    useThisTemplateCTA: string;
    getStartedCTA: string;
    relatedTemplatesString: string;
    usePARF: boolean;
}

const PresentationTemplateRoot: React.FunctionComponent<PresentationTemplateRootProps> = (props: PresentationTemplateRootProps) => {
    return (
        <BrowserRouter>
            <App
                categories = { props.categories }
                templates = { props.templates }
                isAuthenticated={ props.isAuthenticated }
                preloadTemplatePreviewVideos={ props.preloadTemplatePreviewVideos }
                categoryString={ props.categoryString }
                useThisTemplateCTA={ props.useThisTemplateCTA }
                getStartedCTA={ props.getStartedCTA }
                relatedTemplatesString={ props.relatedTemplatesString }
                usePARF={ props.usePARF }
            />
        </BrowserRouter>
    );
};

export default PresentationTemplateRoot;



// WEBPACK FOOTER //
// ./assets/js/components/rootComponents/PresentationTemplateRoot.tsx